import { Play, Clock } from "lucide-react";

/**
 * Compact status panel for the 3 scheduled email jobs.
 * Props:
 *  - data: {enabled, jobs, sent_30d}
 *  - onRun: (job: 'welcome'|'events'|'reengagement') => void
 */
export default function AutomationsPanel({ data, onRun }) {
  if (!data) return null;
  return (
    <div className="bg-white border border-stone-200 p-6 mb-6" data-testid="automations-panel">
      <div className="flex items-end justify-between mb-4">
        <div>
          <div className="text-xs uppercase tracking-wider text-ccc-gold-dark mb-1">Automations</div>
          <h2 className="font-serif text-2xl text-ccc-plum">Scheduled email sequences.</h2>
          <div className="text-xs text-stone-500 mt-1">
            {data.enabled ? "Scheduler is running." : "Scheduler is disabled."}
          </div>
        </div>
        <div className="flex gap-2">
          <button onClick={() => onRun("welcome")} data-testid="run-welcome"
            className="text-xs uppercase tracking-wider px-3 py-1.5 border border-stone-300 hover:border-ccc-purple inline-flex items-center gap-1">
            <Play size={12}/> Run Welcome
          </button>
          <button onClick={() => onRun("events")} data-testid="run-events"
            className="text-xs uppercase tracking-wider px-3 py-1.5 border border-stone-300 hover:border-ccc-purple inline-flex items-center gap-1">
            <Play size={12}/> Run Events
          </button>
          <button onClick={() => onRun("reengagement")} data-testid="run-reengagement"
            className="text-xs uppercase tracking-wider px-3 py-1.5 border border-stone-300 hover:border-ccc-purple inline-flex items-center gap-1">
            <Play size={12}/> Run Re-engagement
          </button>
        </div>
      </div>
      <div className="grid md:grid-cols-3 gap-3">
        {data.jobs?.map(j => (
          <div key={j.id} className="border border-stone-200 p-3">
            <div className="text-sm font-medium text-ccc-plum">{j.id.replace(/_/g, " ")}</div>
            <div className="text-xs text-stone-500 mt-1 inline-flex items-center gap-1">
              <Clock size={11}/> next {j.next_run ? new Date(j.next_run).toLocaleString() : "—"}
            </div>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-5 gap-2 mt-4 text-center text-xs">
        {Object.entries(data.sent_30d || {}).map(([k, v]) => (
          <div key={k} className="border border-stone-100 p-2">
            <div className="text-stone-500 uppercase tracking-wider">{k.replace(/_/g, " ")}</div>
            <div className="font-serif text-2xl text-ccc-plum">{v}</div>
            <div className="text-[10px] text-stone-400">last 30d</div>
          </div>
        ))}
      </div>
    </div>
  );
}
